var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"json-tree-view"},[_c('JsonNode',{ref:"rootNode",attrs:{"data":_vm.data,"keyName":'root',"depth":0,"maxDepth":_vm.maxDepth,"searchQuery":_vm.searchQuery,"readOnly":_vm.readOnly,"path":[]},on:{"update":_vm.handleUpdate,"first-match":_vm.handleFirstMatch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }